import { useAppSelector } from '../redux/hooks';
import { contentDataSelector } from '../redux/selectors';
import { validateConditions } from '../conditions';
import { useKenticoContentErrorNotify } from '../kentico/contentErrors';
export const useDestination = (paths) => {
    const contentErrorNotify = useKenticoContentErrorNotify();
    const contentData = useAppSelector(contentDataSelector);
    try {
        return traverseDestinationList(paths, contentData, []);
    }
    catch (err) {
        if (err.contentItem) {
            contentErrorNotify(err.message, { contentItem: err.contentItem });
        }
        throw err;
    }
};
/**
 * Depth first traversal of paths/path groups.
 *
 * @returns destination codename for first path with a Condition that evaluates to `true`,
 * or first path with no Condition.
 */
function traverseDestinationList(pathList, contentData, seenCodeNames) {
    for (const p of pathList) {
        let destination;
        seenCodeNames.push(p.system.codename);
        if (isPathGroup(p)) {
            destination = traverseDestinationList(p.elements.paths.linkedItems, contentData, seenCodeNames);
        }
        else {
            destination = traversePath(p, contentData, seenCodeNames);
        }
        if (destination) {
            return destination;
        }
    }
}
function traversePath(path, contentData, seenCodeNames) {
    if (validateConditions(path, contentData)) {
        const pathOrGroup = path.elements.destination.linkedItems[0];
        if (!pathOrGroup) {
            return;
        }
        if (seenCodeNames.filter((c) => c === path.system.codename).length > 1) {
            throw new RecursivePathError(`Recursive routing detected. Path "${path.system.codename}" routes to a path that's already been taken: ${seenCodeNames.join(' -> ')}`, path);
        }
        if (isPathGroup(pathOrGroup)) {
            seenCodeNames.push(pathOrGroup.system.codename);
            return traverseDestinationList(pathOrGroup.elements.paths.linkedItems, contentData, seenCodeNames);
        }
        return pathOrGroup.system.codename;
    }
}
class RecursivePathError extends Error {
    contentItem;
    constructor(message, contentItem) {
        super(message);
        this.name = 'RecursivePathError';
        this.contentItem = contentItem;
    }
}
// I cannot figure out how to use Kentico types in a discriminated union, so I have to write
// these type assertions.  If you can figure out how to do that, then this type assertion can
// go away!
function isPathGroup(value) {
    return value.system.type === 'path_group';
}
//# sourceMappingURL=hooks.js.map